module.exports = __webpack_public_path__ + "img/CardThumbnail.03b281fc.png";